import { useGiveawayTimer } from 'root/src/client/web/giveaway/features/GiveawaySection/hooks/useGiveawayTimer';
import { PickingWinner } from 'root/src/client/web/giveaway/features/GiveawaySection/PickingWinner';
import { memo } from 'react';
import { twMerge } from 'tailwind-merge';
import { TimeLeftCountdown } from 'root/src/client/web/giveaway/features/GiveawaySection/TimeLeftCountdown';
export const GiveawayTimer = memo(() => {
    const { classes, isPickingWinner, timeLeftParts, timeLeft } = useGiveawayTimer();
    if (isPickingWinner) {
        return <PickingWinner />;
    }
    const isAlerting = timeLeft < (20 * 1000); // 20 seconds in milliseconds
    return (<div className={classes.activeGiveawayInfo}>
			<span className={classes.timeRemainingLabel}>Giveaway time remaining</span>
			<div className={twMerge(classes.timeRemaining, isAlerting && 'animate-pulse !text-pink')}>
				<TimeLeftCountdown {...timeLeftParts}/>
			</div>
		</div>);
});
